import React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import RssFeedModel from '@mm/state/model/RssFeedModel';
import { DEFAULT_DESCRIPTION_LABEL } from '../../constants/texts';
import RssFeedCRUDActions from '@mm/state/actions/RssFeedCRUDActions';
import TextInput from '../../../../../common/components/TextInput';
import './RssFeedDetails.scss';

type OnDescriptionChange = () => { descriptionButtonLabel: string };
type SetDescriptionButtonLabel = ({ descriptionButtonLabel: string }) => void;
type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;
type PropsFromWithState = {
  descriptionButtonLabel: string;
  setDescriptionButtonLabel: (value: string) => string;
};

type PropsFromWithHandler = {
  onDescriptionChange: ReturnType<typeof onDescriptionChange>;
};

type InnerProps = OnDescriptionChange &
  SetDescriptionButtonLabel &
  PropsFromDispatch &
  PropsFromWithState &
  PropsFromWithHandler;

type OuterProps = {
  feed: RssFeedModel;
  chatbotId: number;
};

type OwnProps = OuterProps & PropsFromWithState & PropsFromWithHandler;

type Props = OuterProps & InnerProps;

const mapDispatchToProps = (
  dispatch: Dispatch<StoreState>,
  ownProps: OwnProps,
) => ({
  updateFeed: () => {
    const { feed, chatbotId } = ownProps;
    const label =
      ownProps.descriptionButtonLabel && ownProps.descriptionButtonLabel.trim();
    if (feed.descriptionButtonLabel !== label) {
      const nextLabel = label || DEFAULT_DESCRIPTION_LABEL;
      const newFeed = Object.assign({}, feed, {
        descriptionButtonLabel: nextLabel,
      });
      ownProps.setDescriptionButtonLabel(nextLabel);
      return dispatch(RssFeedCRUDActions.update(chatbotId, newFeed));
    }
    return null;
  },
});

const DescriptionTextInput = (props: Props) => {
  const { descriptionButtonLabel, onDescriptionChange, updateFeed } = props;
  return (
    <div className="feed-details__input-container">
      <div className="feed-details__field-title">
        &quot;Read More&quot; Button Text
      </div>
      <TextInput
        maxLength={20}
        className="feed-details__feed-name"
        value={descriptionButtonLabel}
        onChange={onDescriptionChange}
        onBlur={updateFeed}
        onMouseLeave={updateFeed}
      />
    </div>
  );
};

const onDescriptionChange =
  ({ setDescriptionButtonLabel }) =>
  e =>
    setDescriptionButtonLabel(e.target.value);

const enhance = compose<InnerProps, OuterProps>(
  withState(
    'descriptionButtonLabel',
    'setDescriptionButtonLabel',
    ({ feed: { descriptionButtonLabel } }) => descriptionButtonLabel,
  ),
  withHandlers<Props, {}>({ onDescriptionChange }),
  connect(null, mapDispatchToProps),
);

export default enhance(DescriptionTextInput);
